// Set global to check if input has been focused yet
var firstTimeFocused = false;

jQuery.fn.isInViewport = function() {
    var elementTop = jQuery(this).offset().top;
    var elementBottom = elementTop + jQuery(this).outerHeight();

    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();

    return elementTop > viewportTop && elementBottom < viewportBottom;
};

jQuery.fn.reduce = Array.prototype.reduce;

// UpNest buy/sell widget initialization
function initUpNestBuySell(pos, headline, cta, location, type, refer) {
    jQuery("#UpNestBuySellContainer").show();
    jQuery("#UpNestBuySellContainer").addClass("buysell-widget");
    jQuery("#UpNestBuySellContainer").before('<div id="UpNestBuySellContainerPosMarker"></div>');

    // Get positioning mode in pos argument string (required), choose between 'inline', 'popup', 'fixed', 'both'
    var position = "";
    if (pos == "inline") {
        // 'inline' will just display the form where the container is placed
        position = "";
    } else if (pos == "popup") {
        // 'popup' should be utilized from an event, usually a click but can be called on page load
        position = "popup";
    } else if (pos == "fixed") {
        // 'fixed' will float the widget on the bottom of the page, it is not accessible from mobile
        position = "fixed";
    } else if (pos == "both") {
        // 'both' will initialize both the fixed floating version and the inline version, this will also ignore fixed for mobile
        position = "fixed";
        // Creates a dummy background to server as placeholder while the widget is floating
        jQuery("#UpNestBuySellContainer").after('<div id="UpNestBuySellContainer2"></div>');
    }

    //hide dummy background for mobile
    if (jQuery(window).width() < 768 && (pos == "fixed" || pos == "both")) {
        jQuery("#UpNestBuySellContainer2").hide();
    }

    var scrollTop = 0;

    jQuery(window).scroll(function() {
        var inlineBuysellVisible = jQuery("input[name=location]:not(#locationForm.location-input)").filter(function() {
            return jQuery(this).isInViewport();
        });

        if (inlineBuysellVisible.length) {
            jQuery("#UpNestBuySellContainer").hide();
            return;
        } else {
            jQuery("#UpNestBuySellContainer").show();
        }
    });
    var savedScrollPos = scrollTop;

    setTimeout(function() {
        jQuery("#UpNestBuySellContainer input[name=location]")
            .on("touchstart", function() {
                if (is_iOS() && (pos == "fixed" || pos == "both")) {
                    savedScrollPos = scrollTop;
                    jQuery("body").css({
                        position: "relative",
                        top: -(scrollTop - 10),
                    });
                    jQuery("html").css("overflow", "hidden");
                }
            })
            .blur(function() {
                if (is_iOS() && (pos == "fixed" || pos == "both")) {
                    jQuery("body, html").removeAttr("style");
                    jQuery(document).scrollTop(savedScrollPos);
                }
            });
    }, 1000);

    // Special code for the 'popup' pos
    if (position == "popup") {
        jQuery("#UpNestBuySellContainer").addClass("popup");
        // Bind a close function to the background and close button
        jQuery("#UpNestBuySellContainer, #UpNestBuySellContainer .closeBtn").on(
            "click",
            function(e) {
                if (
                    e.target == document.querySelector("div#UpNestBuySellContainer.popup") ||
                    e.target == document.querySelector("div.closeBtn")
                ) {
                    jQuery("#UpNestBuySellContainer").fadeOut(function() {
                        //to close, destroy everything and return to default
                        jQuery("#UpNestBuySellContainer").html("");
                        jQuery("#UpNestBuySellContainer").attr("class", "");
                    });
                }
            }
        );
    } else if (position == "fixed") {
        // Add fixed class by default to container and google dropdown
        jQuery("#UpNestBuySellContainer").addClass("fixed");
        setTimeout(function() {
            jQuery(".pac-container").addClass("fixed");
            jQuery(".pac-container").addClass("widget");
        }, 3000);
        jQuery(window).scroll(function() {
            if (jQuery(window).width() >= 768) {
                if (
                    jQuery(window).scrollTop() + jQuery(window).height() >=
                    jQuery(document).height()
                ) {
                    jQuery("#UpNestBuySellContainer").addClass("hidden");
                } else {
                    jQuery("#UpNestBuySellContainer").removeClass("hidden");
                }
            }
        });
    }

    // CTA is an argument string that is not required. Default messaging below
    cta = cta == null ? "Compare Agents" : cta;

    // Location is an argument string that is used to prefill the form but it is not required
    location = location ? location : "";

    // Type is an argument string that is not required. Can either deep link to buy or sell flow or be left out to display both.
    var clientType = "";
    if (type == "buy") {
        clientType = '<input type="hidden" name="buyer" value="true"/>';
    } else if (type == "sell") {
        clientType = '<input type="hidden" name="seller" value="true"/>';
    }

    // Refer is an argument string that is not required.
    var referral = "";
    if (refer) {
        referral = '<input type="hidden" name="refer" value="' + refer + '"/>';
    }

    // Log fsp
    var fsp =
        '<input type="hidden" name="tag" value="' +
        window.location.pathname +
        '"/>';
    var kw = jQuery("meta[name=kw]").attr("content");
    var campaign = jQuery("meta[name=campaign]").attr("content");
    // Render the container code

    var title = headline
        ? '<div class="title-wrapper">' +
        '<div class="title">' +
        headline +
        "</div>" +
        "</div>"
        : "";
    jQuery("#UpNestBuySellContainer").html(
        '<div class="buysell-form-wrapper">' +
        '<form action="https://www.upnest.com/re/create-draft-request2" method="GET" class="buysell-form direction-up">' +
        '<input type="hidden" name="dlink" value="true"/>' +
        clientType +
        referral +
        fsp +
        (kw
            ? jQuery('<input type="hidden" name="kw"/>')
                .val(kw)
                .prop("outerHTML")
            : "") +
        (campaign
            ? jQuery('<input type="hidden" name="campaign"/>')
                .val(campaign)
                .prop("outerHTML")
            : "") +
        '<div class="inputs">' +
        '<input id="locationForm" class="location-input required" name="location" placeholder="City and State, or ZIP" value="' +
        location +
        '"/>' +
        '<a href="javascript:void(0)" onclick="UpNestSubmit(this)" class="next-button">' +
        cta +
        "</a>" +
        "</div>" +
        '<label class="error buysell-submission-error">Please enter a city and state separated by a comma or a 5-digit ZIP code.</label>' +
        "</form>" +
        title +
        "</div>"
    );

    /* GOOGLE PLACES AUTOFILL */
    var input = document.querySelector("#UpNestBuySellContainer form input[name=location]");

    (function pacSelectFirst(input) {
        // Store the original event binding function
        var _addEventListener = input.addEventListener
            ? input.addEventListener
            : input.attachEvent;

        function addEventListenerWrapper(type, listener) {
            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
            // and then trigger the original listener.
            if (type == "keydown") {
                var orig_listener = listener;
                listener = function(event) {
                    var suggestion_selected =
                        jQuery(".pac-item.pac-item-selected").length > 0;
                    if (event.which == 13 && !suggestion_selected) {
                        var simulated_downarrow = jQuery.Event("keydown", {
                            keyCode: 40,
                            which: 40,
                        });
                        orig_listener.apply(input, [simulated_downarrow]);
                        if (jQuery(".pac-item").length > 0) {
                            setTimeout(function() {
                                nextStep();
                            }, 250);
                        } else {
                            if (validationFunction()) {
                                // if(jQuery(window).width() < 768){
                                //   jQuery('#UpNestBuySellContainer.fixed').css('height', '50px');
                                // }
                            } else {
                                // if(jQuery(window).width() < 768){
                                //   jQuery('#UpNestBuySellContainer.fixed').css('height', '86px');
                                // }
                                // jQuery("#UpNestBuySellContainer form input[name=location]").focus();
                                event.preventDefault();
                                return false;
                            }
                        }
                    } else if (event.which == 13 && suggestion_selected) {
                        if (navigator.userAgent.toLowerCase().indexOf("firefox") == -1) {
                            setTimeout(function() {
                                nextStep();
                            }, 250);
                        }
                    }

                    orig_listener.apply(input, [event]);
                };
            }
            _addEventListener.apply(input, [type, listener]);
        }

        input.addEventListener
            ? (input.addEventListener = addEventListenerWrapper)
            : (input.attachEvent = addEventListenerWrapper);
    })(input);

    var options = {
        types: ["(cities)"],
        componentRestrictions: {country: "us"},
    };
    if (window.google) {
        var autocomplete = new google.maps.places.Autocomplete(input, options);

        // Disable copy paste into form
        jQuery("#UpNestBuySellContainer form input[name=location]").on("paste", function(e) {
            e.preventDefault();
        });

        // Clear form the first time it is clicked on
        jQuery("#UpNestBuySellContainer form input[name=location]").on("focus", function() {
            jQuery("#UpNestBuySellContainer").append(jQuery(".pac-container"));

            if (!firstTimeFocused) {
                jQuery("#UpNestBuySellContainer form input[name=location]").val("");
                firstTimeFocused = true;
            }
        });

        jQuery("#UpNestBuySellContainer form input[name=location]").on("blur", function() {
            jQuery(document.body).append(jQuery(".pac-container"));
        });

        google.maps.event.addListener(autocomplete, "place_changed", function() {
            jQuery("#UpNestBuySellContainer form").submit();
        });
    }
}

function validationFunction() {
    var locationForm = jQuery("#locationForm");
    if (
        /(['a-zA-Z ]+,\s*[a-zA-Z].*|\b\d{5}\b)/i.test(locationForm.val()) &&
        locationForm.val() != "City and State, or ZIP"
    ) {
        jQuery(".buysell-submission-error").hide();
        jQuery(".buysell-form-wrapper").removeClass("error");
        return true;
    } else {
        jQuery(".buysell-form-wrapper").addClass("error");
        jQuery(".buysell-submission-error").show();
        return false;
    }
}

function validateOnEnter(e) {
    if (event.keyCode == 13 && validationFunction() == false) {
        e.preventDefault();
        return false;
    }
}

function UpNestSubmit(obj) {
    if (validationFunction()) {
        if (jQuery(window).width() < 768) {
            jQuery("#UpNestBuySellContainer.fixed").css("height", "50px");
        }
        jQuery(obj)
            .closest("form")
            .submit();
    } else {
        if (jQuery(window).width() < 768) {
            jQuery("#UpNestBuySellContainer.fixed").css("height", "86px");
        }
        jQuery("#UpNestBuySellContainer form input[name=location]").focus();
        return false;
    }
}

function is_iOS() {
    var iDevices = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
    ];
    while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
            return true;
        }
    }
    return false;
}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
